import {
    LIST_USERS,
    LIST_USERS_SUCCESS,
    LIST_USERS_ERROR,
    ADD_USERS,
    SAVE_USERS,
    SAVE_USERS_SUCCESS,
    SAVE_USERS_ERROR,
    DELETE_USERS,
    DELETE_USERS_SUCCESS,
    DELETE_USERS_ERROR,
    EDIT_USERS,
    ENABLE_USERS,
    ENABLE_USERS_SUCCESS,
    ENABLE_USERS_ERROR,
    UPDATE_USERS,
    UPDATE_USERS_SUCCESS,
    UPDATE_USERS_ERROR,
    RESET_PASS_USERS,
    RESET_PASS_USERS_SUCCESS,
    RESET_PASS_USERS_ERROR,
    GET_RESET_PASS_TOKEN,
    GET_RESET_PASS_TOKEN_SUCCESS,
    GET_RESET_PASS_TOKEN_ERROR,
    RESET_PASS_TOKEN,
    RESET_PASS_TOKEN_SUCCESS,
    RESET_PASS_TOKEN_ERROR
} from '../types';

import clienteAxios                                                                                 from '../config/axios';
import altAxios                                                                                     from '../config/axiosNoToken';
import Swal                                                                                         from 'sweetalert2';

import { ErrorMessage, SuccessMessage, WaitingMessage }                                             from '../components/extras/toastMessages';
import { MSG_UPDATE_SUCCESS }                                                                       from '../constants/messages';
import { MSG_DELETING, MSG_DELETE_SUCCESS }                                                         from '../constants/messages';
import { MSG_RESET_PASSWORD_SUCCESS, MSG_GET_RESET_PASSWORD_TOKEN, MSG_CHANGE_PASSWORD_SUCCESS }    from '../constants/messages';
import { MSG_ERROR_SERVER, MSG_USER_CREATE_SUCCESS, MSG_USER_NO_EMAIL_CREATE_SUCCESS }              from '../constants/messages';
import { METHOD_DISABLED }                                                                          from '../constants/requestMethods';

const controller = 'usuario';

const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTcxNzk2NDQsInVzZXJfbmFtZSI6IjY3MjgiLCJhdXRob3JpdGllcyI6WyJFTElNSU5BUl9QQVJBTUVUUk9TIiwiTklWRUxFUyIsIlJFU0VSVkFSX0FVRElFTkNJQVMiLCJWRV9SRVBPUlRFUyIsIkNSRUFSX0lOSElCSUNJT05FUyIsIkVMSU1JTkFSX1RVUk5PUyIsIkxJU1RBUl9GVU5DSU9OQVJJT1MiLCJNT0RJRklDQVJfSlVFQ0VTIiwiQ1JFQVJfVVNVQVJJT1MiLCJNT0RJRklDQVJfVFVSTk9TIiwiRUxJTUlOQVJfSU5ISUJJQ0lPTkVTIiwiTU9ESUZJQ0FSX0ZVTkNJT05BUklPUyIsIkxJU1RBUl9PRklKVVMiLCJNT0RJRklDQVJfU09MSUNJVFVERVMiLCJWRVJfVklERU9TX0FVRElFTkNJQVMiLCJNT0RJRklDQVJfUEFSQU1FVFJPUyIsIk1PRElGSUNBUl9VU1VBUklPUyIsIkxJU1RBUl9KVUVDRVMiLCJFTElNSU5BUl9KVUVDRVMiLCJBR0VOREFSX0FVRElFTkNJQVMiLCJDQU5DRUxBUl9BVURJRU5DSUFTIiwiQ1JFQVJfUkVTVUxUQURPUyIsIkNSRUFSX1RVUk5PUyIsIk1PRElGSUNBUl9JTkhJQklDSU9ORVMiLCJMSVNUQVJfSU5ISUJJQ0lPTkVTIiwiRUxJTUlOQVJfVVNVQVJJT1MiLCJMSVNUQVJfVVNVQVJJT1MiLCJDUkVBUl9OT1RJRklDQUNJT05FUyIsIkNSRUFSX09GSUpVUyIsIlZFUl9BR0VOREEiLCJDUkVBUl9TT0xJQ0lUVURFUyIsIkVMSU1JTkFSX09GSUpVUyIsIkxJU1RBUl9QQVJBTUVUUk9TIiwiTU9ESUZJQ0FSX09GSUpVUyIsIlZFUl9BQ1RBU19BVURJRU5DSUFTIiwiRUxJTUlOQVJfRlVOQ0lPTkFSSU9TIiwiUkVWT0NBUl9TT0xJQ0lUVURFUyIsIkFDRVBUQVJfU09MSUNJVFVERVMiLCJMSVNUQVJfVFVSTk9TIiwiVkVSX0FDVEFTX0FVRElFTkNJQVNfUFJPUElBUyIsIkNSRUFSX0ZVTkNJT05BUklPUyIsIkNSRUFSX1BBUkFNRVRST1MiLCJWRVJfVklERU9TX0FVRElFTkNJQVNfUFJPUElBUyIsIkNSRUFSX0pVRUNFUyIsIlJFQ0hBWkFSX1NPTElDSVRVREVTIl0sImp0aSI6IjliNDIzYmJkLWNjYmUtNGE3ZS1iZDMwLTA1ZDIyNzRkZmE0YSIsImNsaWVudF9pZCI6ImZyb250ZW5kYXBwIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIl19.r0oYOih943bE0kyj5wZAX9K6emEZTCaRgrtYangXEzM';


//LISTAR USERS
export function listUsersAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listUsers() );
        //Ejecuto la consulta
        try {
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const users = response.data;
            //Llamo al dispatch
            dispatch( listUsersSuccess(users) );
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( listUsersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listUsers = () => ({
    type: LIST_USERS,
    payload: true
});

const listUsersSuccess = users => ({
    type: LIST_USERS_SUCCESS,
    payload: users
});

const listUsersError = error => ({
    type: LIST_USERS_ERROR,
    payload: error
});


//ADD USER
export function addUsersAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addUsers(false) );
        //Abro el formulario
        showForm();
    }
}

const addUsers = isEdit => ({
    type: ADD_USERS,
    payload: isEdit
});


//SAVE USER
export function saveUsersAction(user, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveUsers() );
        //Ejecuto la consulta
        try {
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}/create-send`, user);
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch( saveUsersSuccess(res.usuario) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(res.emailSent ? MSG_USER_CREATE_SUCCESS : `${MSG_USER_NO_EMAIL_CREATE_SUCCESS} ${res.randomPassword}`);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveUsersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveUsers = () => ({
    type: SAVE_USERS,
    payload: true
});

const saveUsersSuccess = user => ({
    type: SAVE_USERS_SUCCESS,
    payload: user
});

const saveUsersError = error => ({
    type: SAVE_USERS_ERROR,
    payload: error
});


//EDIT USER
export function editUsersAction(user, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editUsers(user) );
        //Abro el formulario
        showForm();
    }
}

const editUsers = user => ({
    type: EDIT_USERS,
    payload: user
});


//UPDATE USER
export function updateUsersAction(user, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateUsers() );
        //Ejecuto la consulta
        try {
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${user.id}`, user);
            //Llamo al dispatch
            dispatch( updateUsersSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateUsersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateUsers = () => ({
    type: UPDATE_USERS,
    payload: true
});

const updateUsersSuccess = user => ({
    type: UPDATE_USERS_SUCCESS,
    payload: user
});

const updateUsersError = error => ({
    type: UPDATE_USERS_ERROR,
    payload: error
});


//ENABLE USER
export function enableUsersAction(user) {
    return async (dispatch) => {
        dispatch( enableUsers() );
        try {            
            const response = await clienteAxios.put(`/${controller}/${user.id}/activar`);
            dispatch( enableUsersSuccess(response.data) );
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            dispatch( enableUsersError(data) );
            ErrorMessage(data.message);
        }
    }
}

const enableUsers = () => ({
    type: ENABLE_USERS,
    payload: true
});

const enableUsersSuccess = user => ({
    type: ENABLE_USERS_SUCCESS,
    payload: user
});

const enableUsersError = error => ({
    type: ENABLE_USERS_ERROR,
    payload: error
});


//DELETE USER
export function deleteUsersAction(user) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteUsers() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try {
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${user.id}/${METHOD_DISABLED}`);
            //Llamo al dispatch
            dispatch( deleteUsersSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteUsersError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteUsers = () => ({
    type: DELETE_USERS,
    payload: true
});

const deleteUsersSuccess = user => ({
    type: DELETE_USERS_SUCCESS,
    payload: user
});

const deleteUsersError = error => ({
    type: DELETE_USERS_ERROR,
    payload: error
});


//RESET PASSWORD
export function resetPasswordUsersAction(user) {
    return async (dispatch) => {
        //Inicializo
        dispatch( resetPasswordUsers() );
        //Ejecuto la consulta
        try {
            //Cargo la espera
            WaitingMessage('Reseteando contraseña');
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}/change-password/${user.id}`);
            //Llamo al dispatch
            dispatch( resetPasswordUsersSuccess(response.data) );
            //Oculto la espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_RESET_PASSWORD_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( resetPasswordUsersError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje
            let message = data.message;
            //Me fijo si hay clave
            if(data.randomPassword)
            {   message = `${message} - Contraseña generada: ${data.randomPassword}`;
            }
            //Mensaje de error
            ErrorMessage(message);
        }
    }
}

const resetPasswordUsers = () => ({
    type: RESET_PASS_USERS,
    payload: true
});

const resetPasswordUsersSuccess = user => ({
    type: RESET_PASS_USERS_SUCCESS,
    payload: user
});

const resetPasswordUsersError = error => ({
    type: RESET_PASS_USERS_ERROR,
    payload: error
});


//GET TOKEN RESET PASSWORD
export function getResetPasswordTokenAction(data) {
    return async (dispatch) => {
        //Inicializo
        dispatch( getResetPasswordToken() );
        //Ejecuto la consulta
        try {
            //Cargo la espera
            WaitingMessage('Enviando solicitud');
            //Hago la consulta
            const response = await altAxios.post(`/${controller}/get-password-token`, data);
            //Llamo al dispatch
            dispatch( getResetPasswordTokenSuccess(response.data) );
            //Oculto la espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_GET_RESET_PASSWORD_TOKEN);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( getResetPasswordTokenError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const getResetPasswordToken = () => ({
    type: GET_RESET_PASS_TOKEN,
    payload: true
});

const getResetPasswordTokenSuccess = data => ({
    type: GET_RESET_PASS_TOKEN_SUCCESS,
    payload: data
});

const getResetPasswordTokenError = error => ({
    type: GET_RESET_PASS_TOKEN_ERROR,
    payload: error
});


//RESET PASSWORD WITH TOKEN
export function resetPasswordTokenAction(data, history) {
    return async (dispatch) => {
        //Inicializo
        dispatch( resetPasswordToken() );
        //Ejecuto la consulta
        try {
            //Cargo la espera
            WaitingMessage('Reseteando contraseña');
            //Hago la consulta
            const response = await altAxios.post(`/${controller}/reset-password`, data);
            //Llamo al dispatch
            dispatch( resetPasswordTokenSuccess(response.data) );
            //Oculto la espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_CHANGE_PASSWORD_SUCCESS);
            //Mando al usuario al logueo
            history.push('/iniciar-sesion');
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( resetPasswordTokenError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const resetPasswordToken = () => ({
    type: RESET_PASS_TOKEN,
    payload: true
});

const resetPasswordTokenSuccess = data => ({
    type: RESET_PASS_TOKEN_SUCCESS,
    payload: data
});

const resetPasswordTokenError = error => ({
    type: RESET_PASS_TOKEN_ERROR,
    payload: error
});